import React, { FC } from "react";

import { usePlotPlanClipImage } from "@/sx-layout/hooks/usePlotPlanClipImage";
import { PlotPlanMapping } from "@/sx-layout/hooks/usePlotPlanMappingApi";
import { normalizeHexColor } from "@/sx-layout/utils";

type Props = {
  plotPlanMapping: PlotPlanMapping;
  opacity?: "zero" | "rect" | "hybrid" | "image";
};

const PlotPlanMappingAreaComponent: FC<Props> = ({ plotPlanMapping, opacity = "rect" }) => {
  const { clipImageUrl } = usePlotPlanClipImage(plotPlanMapping);

  const color = normalizeHexColor(plotPlanMapping.color);

  return (
    <div className="relative flex h-full w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        {clipImageUrl && (
          <img
            src={clipImageUrl}
            alt=""
            className="block h-full w-full object-fill"
            style={{
              opacity: opacity === "rect" ? 0 : opacity === "hybrid" ? 0.5 : 1,
            }}
          />
        )}
      </div>
      <div
        className="pointer-events-none absolute inset-0 z-[1]"
        style={{
          backgroundColor: color,
          opacity: opacity === "zero" ? 0 : 0.3,
        }}
      />
    </div>
  );
};

export const PlotPlanMappingArea = React.memo(PlotPlanMappingAreaComponent);
